// extracted by mini-css-extract-plugin
module.exports = {"talkWords":"TalkWords_talkWords__GSBKX"};